import metadata from './payDirFormConfig/payDirMetadata'
export { metadata }
import { IResponseInterface } from '../interfaces'
/*
@Saiman

*/
export {
  accordianConfigObject,
  appBarConfigObject,
  footerConfigObject,
  layoutConfigObject,
} from './boxConfig'

/*
@Gowtham
@responseCodes :
 - required types of response codes and messages related to status code
*/

export enum PathParams {
  GET_API_MERCHANT_SEARCH = 'merchant/search/pay-index',
  POST_APT_TRANSACTION = 'transaction',
}

/*
@Gowtham
@responseCodes :
 - required types of response codes and messages related to status code
*/
export const responseCodes: IResponseInterface[] = [
  {
    code: 200,
    type: 'success',
    message: 'Successful',
  },
  {
    code: 201,
    type: 'success',
    message: 'Successfully Created',
  },
  {
    code: 401,
    type: 'error',
    message: 'Unauthorized',
  },
  {
    code: 402,
    type: 'error',
    message: 'Payment Required',
  },
  {
    code: 404,
    type: 'error',
    message: 'Not Found',
  },
  {
    code: 400,
    type: 'error',
    message: 'Bad Request',
  },
  {
    code: 500,
    type: 'error',
    message: 'Internal Server Error',
  },
]

/*
@Hemanth
@Footer :
 - Footer Links Labels
*/
export const FooterLinks = {
  privacyPolicy: 'Privacy Policy',
  // netData: 'NETData',
  companyName: 'i3 Verticals',
  termsAndConditions: 'Terms and Conditions',
}
